import React from 'react';
import {Redirect} from 'react-router';
import Loader from '../../../components/Loader';
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, convertToRaw} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import withStyles from "@material-ui/core/styles/withStyles";

import ImageUpload from "components/CustomUpload/ImageUpload.jsx";

import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from '@material-ui/core/TextField';

import SelectAutoCompleteCity from "components/Forms/ClinicForm/selectAutoCompleteCity.jsx"
import SelectAutoCompleteState from "components/Forms/ClinicForm/selectAutoCompleteState.jsx"

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';

import Icon from '@material-ui/core/Icon';
import Business from "@material-ui/icons/Business";
import {NavLink} from 'react-router-dom';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import TagInputAutoSuggest from "components/Forms/ClinicForm/TagInputAutoSuggest.jsx";
import ClinicTimings from "components/Forms/ClinicForm/addTimings.jsx";
import ClinicTimingsEdit from "components/Forms/ClinicForm/updateTimings.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";
import api from '../../../api/Api';
import {
    verifyEmail,
    verifyName
    , verifyUrl,
    verifyNumber, verifyPincode, verifyClinicPhoneNumber,
    verifyPhoneNumber, isClinicMasterOrClinic, clinicmaster_id, dashboardRouter
} from '../../../util/globalHelper'
class ValidationForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            clinic_master_id: "",
            timings: [{"day": "mon", "open_24": false, "open_time": "", "close_time": ""},
                {"day": "tues", "open_24": false, "open_time": "", "close_time": ""},
                {"day": "wednes", "open_24": false, "open_time": "", "close_time": ""},
                {"day": "thurs", "open_24": false, "open_time": "", "close_time": ""},
                {"day": "fri", "open_24": false, "open_time": "", "close_time": ""},
                {"day": "satur", "open_24": false, "open_time": "", "close_time": ""},
                {"day": "sun", "open_24": false, "open_time": "", "close_time": ""}],
            selectedOptionState: '',
            selectedOptionCity: '',
            selectedcityvalue: '',
            selectedstatevalue: '',
            selectedcitylabel: 'Delhi',
            selectedstatelabel: 'Delhi',
            // validation
            number: "",
            home_collection_allowed: false,
            numberState: "",
            name: "",
            nameState: "",
            addressline: "",
            addresslineState: "",
            locality: "",
            localityState: "",
            pincode: "",
            pincodeState: "",
            registerEmail: "",
            registerEmailState: "",
            phoneNumber: "",
            phoneNumberState: "",
            website: "",
            websiteState: "",
            google:"",
            googleState:"",
            location: "",
            services: [],
            description: "",
            alert: null,
            open: true,
            redirect: false,
            simpleSelect: "",
            role: "clinic",
            timingsadded: false,
            imageurl: '',
            headerImageUrl: '',
            footerImageUrl: '',
            generatedclinic_id: "",
            propss: props,
            showDropdown: false,
            secondaryNumber: [],
            secondaryNumberState: [],
            editorState: EditorState.createEmpty(),
            mobile: "",
            mobileState: ""

        };
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this)
        this.hideAlert = this.hideAlert.bind(this);
        this.typeClick = this.typeClick.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this);
        this.CreateAlertForEdit = this.CreateAlertForEdit.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleChangeSecondayNumber = this.handleChangeSecondayNumber.bind(this);
        this.changeSecondaryNumbers = this.changeSecondaryNumbers.bind(this);

    }

    addSecondaryContact() {
        let a = [""];
        let b = this.state.secondaryNumber.concat(a);
        this.setState({secondaryNumber: b})
    }

    onEditorStateChange(editorState) {
        this.setState({
            editorState,
        });
    };

    handleChangeSecondayNumber(e, index) {
        this.state.secondaryNumber[index] = e.target.value;
        this.setState({secondaryNumber: this.state.secondaryNumber})
    }

    changeSecondaryNumbers(event, inputType, index) {
        let a = this.state.secondaryNumber.slice(); //creates the clone of the state
        a[index] = event.target.value;
        this.state.secondaryNumber[index] = event.target.value;
        this.setState({secondaryNumber: this.state.secondaryNumber});
        if (verifyClinicPhoneNumber(event.target.value)) {
            let state = this.state;
            this.state.secondaryNumberState[index] = "success";
            this.setState(state);
        } else if (event.target.value === "" && inputType === "optional") {
            let state = this.state;
            this.state.secondaryNumberState[index] = "none";
            this.setState(state);
        }
        else {
            let state = this.state;
            this.state.secondaryNumberState[index] = "error";
            this.setState(state);
        }
    }

    componentDidMount() {
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({clinicMasterList: {}, clinic_master_id: clinicmaster_id()});
        this.props.id.match.params.clinicmasterID ? this.setState({clinic_master_id: this.props.id.match.params.clinicmasterID}) :
            this.setState({showDropdown: true})

    }

    componentDidUpdate() {

    }

    handleSelectStateChange(selectedOptionState) {
        this.setState({selectedOptionState});
        if (selectedOptionState) {
            this.setState({
                selectedstatevalue: selectedOptionState.value,
                selectedstatelabel: selectedOptionState.label
            });
        }
    }

    handleSelectCityChange(selectedOptionCity) {
        this.setState({selectedOptionCity});
        if (selectedOptionCity) {
            this.setState({selectedcityvalue: selectedOptionCity.value, selectedcitylabel: selectedOptionCity.label});
        }
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    handleChangeCategories(categories) {
        this.setState({
            categories: categories.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        })
    }

    handleChangeServices(services) {
        this.setState({
            services: services.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        });
    }

    handleImageUrl(url) {
        this.setState({imageurl: url});
    }

    headerImageUrl(url) {
        this.setState({headerImageUrl: url});
    }

    footerImageUrl(url) {
        this.setState({footerImageUrl: url});
    }

    handleTimings(timings) {
        this.setState({timings});
        this.setState({timingsadded: true});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyClinicPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "pincode":
                if (verifyPincode(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "url":
                if (verifyUrl(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                }
                else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                }
                else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    CreateAlert() {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title"><ClinicTimings
                        generateNotification={this.props.id.generateNotification.bind(this)}
                        handleTimings={this.handleTimings.bind(this)}
                        hideAlert={this.hideAlert.bind(this) }/></DialogTitle>
                </Dialog>
            )
        });
    }

    CreateAlertForEdit() {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title"><ClinicTimingsEdit
                        generateNotification={this.props.id.generateNotification.bind(this)}
                        handleTimings={this.handleTimings.bind(this)} hideAlert={this.hideAlert.bind(this)}
                        timings={this.state.timings}/></DialogTitle>
                </Dialog>
            )
        });
    }

    typeClick() {
        if (this.state.name === "") {
            this.props.id.generateNotification({message: "Please fill the name!", color: "danger"});
            this.setState({nameState: "error"});

        }
        else if (this.state.phoneNumber === "") {
            this.props.id.generateNotification({message: "Please fill the number!", color: "danger"});
            this.setState({phoneNumberState: "error"});
        }
        else if (this.state.registerEmailState === "") {
            this.setState({registerEmailState: "error"});
            this.props.id.generateNotification({message: "Please fill the email!", color: "danger"});

        }
        else if (this.state.clinic_master_id === "") {
            this.props.id.generateNotification({message: "Please select clinic master!", color: "danger"});
        }
        else if (this.state.addresslineState === "" &&
            this.state.localityState === "" && this.state.pincodeState === "") {
            this.setState({localityState: "error", addresslineState: "error", pincodeState: "error"});
            this.props.id.generateNotification({message: "Please fill the address!", color: "danger"});

        }
        else if (this.state.nameState === "success" && this.state.phoneNumberState === "success" && this.state.addresslineState !== "error" &&
            this.state.secondaryNumberState !== "error" && this.state.registerEmailState !== "error" && this.state.websiteState !== "error" && this.state.localityState !== "error" && this.state.pincodeState !== "error") {
            var address = {
                "addressline": this.state.addressline,
                "locality": this.state.locality,
                "city": this.state.selectedcitylabel,
                "state": this.state.selectedstatelabel,
                "pincode": this.state.pincode
            }
            var images = [];
            images.push(this.state.imageurl);
            var data = {
                clinic_name: this.state.name,
                website: this.state.website,
                google_map_link:this.state.google,
                contact: this.state.phoneNumber,
                timings: this.state.timings,
                email: this.state.registerEmail,
                images: images,
                description: draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())),
                location: this.state.location,
                categories: this.state.categories,
                address: address,
                home_collection_allowed: this.state.home_collection_allowed,
                services: this.state.services,
                clinic_master_id: this.state.clinic_master_id,
                secondary_numbers: this.state.secondaryNumber.filter(function (value, index, arr) {
                    return value !== "";
                }).map(item => {
                    return {
                        label: "Reception",
                        number: item
                    }
                }),
                report_header: this.state.headerImageUrl,
                report_footer: this.state.footerImageUrl,
                mobile: this.state.mobile
            };
            this.CallCreateApi(data);
            // this.CallTagMaster();
            // this.CallTagMasterServices();
        }
        else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    handleDescriptionChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    CallCreateApi(data) {
        api.createClinic(data)
            .then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({generatedclinic_id: json.data.data.clinic_id}, () => {
                        this.setState({redirect: true});
                        var msgcolor = {message: "Clinic Added Successfully!", color: "success"};
                        this.props.id.generateNotification(msgcolor);
                        this.props.id.history.push(dashboardRouter(`/clinic/oneClinic/${json.data.data.clinic_id}`))
                    })
                }
            }).catch(error => {
            var msgcolor = {message: "Server error!", color: "success"};
            this.props.id.generateNotification(msgcolor);
        })
    }

    CallTagMaster() {
        var data = {
            category_text: this.state.categories,
            category_role: this.state.role
        }
        api.createCategory(data)
            .then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                }
            });
    }

    CallTagMasterServices() {
        var data = {
            service_text: this.state.services,
            service_role: this.state.role
        }
        api.createService(data)
            .then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                }
            });
    }

    render() {
        const {classes} = this.props;
        const {clinicMasterList, editorState} = this.state;
        if (this.state.clinicMasterList)
            return (
                <div>
                    {this.state.alert}
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" icon>
                                    <CardIcon color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <Business />
                                            </GridItem>
                                            <GridItem style={{marginTop: 5}}>
                                                <h4 className={classes.cardTitle}>Add Clinic</h4>
                                            </GridItem>
                                        </GridContainer>
                                    </CardIcon>
                                </CardHeader>
                                <CardBody>
                                    <form>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <CustomInput
                                                    labelText="Name"
                                                    id="name"
                                                    success={this.state.nameState === "success"}
                                                    error={this.state.nameState === "error"}
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "name", "name", "required")
                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <CustomInput
                                                    success={this.state.registerEmailState === "success"}
                                                    error={this.state.registerEmailState === "error"}
                                                    labelText="Email "
                                                    id="registeremail"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "registerEmail", "email", "optional"),
                                                        type: "email"
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <CustomInput
                                                    labelText="Phone Number"
                                                    success={this.state.phoneNumberState === "success"}
                                                    error={this.state.phoneNumberState === "error"}
                                                    id="phonenumber"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "phoneNumber", "phonenumber", "required")
                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <CustomInput
                                                    labelText="Website"
                                                    success={this.state.websiteState === "success"}
                                                    error={this.state.websiteState === "error"}
                                                    id="phonenumber"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "website", "url", "optional"),
                                                        startAdornment: (
                                                            <InputAdornment position="start">http://</InputAdornment>)
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <legend>Description</legend>
                                                        <div style={{minHeight: '100px'}}>
                                                            <Editor
                                                                editorState={editorState}
                                                                wrapperClassName="wrapper-class"
                                                                editorClassName="editor-class"
                                                                toolbarClassName="toolbar-class"
                                                                onEditorStateChange={this.onEditorStateChange}
                                                            />
                                                        </div>
                                                        {/*<TextField*/}
                                                        {/*id="multiline-flexible"*/}
                                                        {/*label="Description"*/}
                                                        {/*multiline*/}
                                                        {/*rows="4"*/}
                                                        {/*value={this.state.description}*/}
                                                        {/*onChange={this.handleDescriptionChange('description')}*/}
                                                        {/*className={classes.textField}*/}
                                                        {/*style={{width: "100%"}}*/}
                                                        {/*margin="normal"*/}
                                                        {/*/>*/}
                                                    </GridItem>
                                                </GridContainer>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <br />
                                                        <legend>Address</legend>
                                                        <CustomInput
                                                            labelText="Address Line 1"
                                                            success={this.state.addresslineState === "success"}
                                                            error={this.state.addresslineState === "error"}
                                                            id="addressline"
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                onChange: event =>
                                                                    this.change(event, "addressline", "novalidation", "optional")
                                                            }}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <CustomInput
                                                            labelText="Locality"
                                                            success={this.state.localityState === "success"}
                                                            error={this.state.localityState === "error"}
                                                            id="locality"
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                onChange: event =>
                                                                    this.change(event, "locality", "novalidation", "optional")
                                                            }}
                                                        />
                                                    </GridItem>
                                                    <br />
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <GridContainer>
                                                            <GridItem xs={12} sm={6} md={6}>
                                                                <br />
                                                                <label>City</label>
                                                                <SelectAutoCompleteCity
                                                                    handleSelectCityChange={this.handleSelectCityChange.bind(this)}
                                                                    selectedcityvalue={this.state.selectedcityvalue}/>
                                                                <br />
                                                            </GridItem>
                                                            <GridItem xs={12} sm={6} md={6}>
                                                                <br />
                                                                <label>State</label>
                                                                <SelectAutoCompleteState
                                                                    handleSelectStateChange={this.handleSelectStateChange.bind(this)}
                                                                    selectedstatevalue={this.state.selectedstatevalue}/>
                                                                <br />
                                                            </GridItem>
                                                        </GridContainer>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <CustomInput
                                                            labelText="Pincode"
                                                            success={this.state.pincodeState === "success"}
                                                            error={this.state.pincodeState === "error"}
                                                            id="pincode"
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                onChange: event => this.change(event, "pincode", "pincode", "optional")
                                                            }}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <CustomInput
                                                            labelText="Mobile Alerts"
                                                            success={this.state.mobileState === "success"}
                                                            error={this.state.mobileState === "error"}
                                                            id="mobile"
                                                            formControlProps={{
                                                                fullWidth: true,
                                                                required: true
                                                            }}
                                                            inputProps={{
                                                                onChange: event =>
                                                                    this.change(event, "mobile", "phonenumber", "required")
                                                            }}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <FormControl
                                                            fullWidth
                                                            className={classes.selectFormControl}
                                                            style={{padding: '10px 0'}}>
                                                            <InputLabel
                                                                htmlFor="service"
                                                                className={classes.selectLabel}>
                                                                Home Collection
                                                            </InputLabel>
                                                            <Select
                                                                MenuProps={{
                                                                    className: classes.selectMenu
                                                                }}
                                                                classes={{
                                                                    select: classes.select
                                                                }}
                                                                value={this.state.home_collection_allowed}
                                                                onChange={e => this.onChangeSelect(e)}
                                                                inputProps={{
                                                                    name: "home_collection_allowed",
                                                                    id: "home_collection_allowed"
                                                                }}><MenuItem
                                                                disabled
                                                                classes={{
                                                                    root: classes.selectMenuItem
                                                                }}>
                                                                Select Home Collection Type </MenuItem>
                                                                <MenuItem
                                                                    classes={{root: classes.selectMenuItem}}
                                                                    value={true}>
                                                                    Yes </MenuItem>
                                                                <MenuItem
                                                                    classes={{root: classes.selectMenuItem}}
                                                                    value={false}>
                                                                    No </MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </GridItem>
                                                    {isClinicMasterOrClinic() === "" && this.state.showDropdown ?
                                                        <GridItem xs={12} sm={12} md={12}>
                                                            <FormControl
                                                                fullWidth
                                                                className={classes.selectFormControl}>
                                                                <InputLabel
                                                                    htmlFor="clinic_master_id"
                                                                    className={classes.selectLabel}>
                                                                    Clinic Master
                                                                </InputLabel>
                                                                <Select
                                                                    MenuProps={{
                                                                        className: classes.selectMenu
                                                                    }}
                                                                    classes={{
                                                                        select: classes.select
                                                                    }}
                                                                    value={this.state.clinic_master_id}
                                                                    onChange={this.onChangeSelect}
                                                                    inputProps={{
                                                                        name: "clinic_master_id",
                                                                        id: "clinic_master_id"
                                                                    }}
                                                                >
                                                                    <MenuItem
                                                                        disabled
                                                                        classes={{
                                                                            root: classes.selectMenuItem
                                                                        }}>
                                                                        Select Clinic
                                                                    </MenuItem>
                                                                    {clinicMasterList.map((x) => {
                                                                        return <MenuItem key={Math.random()}
                                                                                         classes={{root: classes.selectMenuItem}}
                                                                                         style={{height: "1.8em"}}
                                                                                         value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                                    })}
                                                                </Select>
                                                            </FormControl>
                                                        </GridItem> : null}
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <CustomInput
                                                            labelText="Google Map Link"
                                                            success={this.state.googleState === "success"}
                                                            error={this.state.googleState === "error"}
                                                            id="phonenumber"
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                onChange: event =>
                                                                    this.change(event, "google", "url", "optional"),
                                                                value: this.state.google,
                                                                startAdornment: (
                                                                    <InputAdornment position="start">http://</InputAdornment>)
                                                            }}
                                                        />
                                                    </GridItem>
                                                </GridContainer>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={4}>
                                                        <br />
                                                        <legend>Timings</legend>
                                                    </GridItem>
                                                    {this.state.timingsadded ? (
                                                        <GridItem xs={12} sm={12} md={8}>
                                                            <GridContainer>
                                                                <GridItem xs={12} sm={4} md={6}>
                                                                    <br />
                                                                    <Button block disabled color="success">
                                                                        <Icon style={{fontSize: 15}}>done</Icon>
                                                                        <span style={{marginLeft: 15}}>  Added  </span>
                                                                    </Button>
                                                                </GridItem>
                                                                <GridItem xs={12} sm={4} md={6}>
                                                                    <br />
                                                                    <Button block color="warning"
                                                                            onClick={this.CreateAlertForEdit}>Edit</Button>
                                                                    <br />
                                                                </GridItem>
                                                            </GridContainer>
                                                        </GridItem>) : (
                                                        <GridItem xs={12} sm={4} md={4}>
                                                            <br />
                                                            <Button block color="warning"
                                                                    onClick={this.CreateAlert}>Add</Button>
                                                            <br />
                                                        </GridItem>) }
                                                </GridContainer>
                                                <GridContainer>
                                                    <GridItem xs={12}>
                                                        <br />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={4}>
                                                        <legend>Categories</legend>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={8}>
                                                        <TagInputAutoSuggest
                                                            handleChangeCategories={this.handleChangeCategories.bind(this)}
                                                            categories={this.state.categories} role={this.state.role}
                                                            tagname="category"/>
                                                    </GridItem>
                                                </GridContainer>

                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={4}>
                                                        <legend>Services</legend>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={8}>
                                                        <TagInputAutoSuggest
                                                            handleChangeServices={this.handleChangeServices.bind(this)}
                                                            services={this.state.services} role={this.state.role}
                                                            tagname="service"/>
                                                    </GridItem>
                                                </GridContainer>


                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={4}>
                                                        <br />
                                                        <legend>Image</legend>
                                                        <br />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={8}>
                                                        <ImageUpload
                                                            addButtonProps={{
                                                                color: "warning",
                                                                round: false
                                                            }}
                                                            changeButtonProps={{
                                                                color: "warning",
                                                                round: false
                                                            }}
                                                            removeButtonProps={{
                                                                color: "grey",
                                                                round: false
                                                            }}
                                                            handleImageUrl={this.handleImageUrl.bind(this)}
                                                            role="Clinic"
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={4}>
                                                        <br />
                                                        <legend>Header</legend>
                                                        <br />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={8}>
                                                        <ImageUpload
                                                            addButtonProps={{
                                                                color: "warning",
                                                                round: false
                                                            }}
                                                            changeButtonProps={{
                                                                color: "warning",
                                                                round: false
                                                            }}
                                                            removeButtonProps={{
                                                                color: "grey",
                                                                round: false
                                                            }}
                                                            handleImageUrl={this.headerImageUrl.bind(this)}
                                                            role="Clinic"
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={4}>
                                                        <br />
                                                        <legend>Footer</legend>
                                                        <br />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={8}>
                                                        <ImageUpload
                                                            addButtonProps={{
                                                                color: "warning",
                                                                round: false
                                                            }}
                                                            changeButtonProps={{
                                                                color: "warning",
                                                                round: false
                                                            }}
                                                            removeButtonProps={{
                                                                color: "grey",
                                                                round: false
                                                            }}
                                                            handleImageUrl={this.footerImageUrl.bind(this)}
                                                            role="Clinic"
                                                        />
                                                    </GridItem>
                                                </GridContainer>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                {this.state.secondaryNumber.map((number, index) => {
                                                    // return <input value={number}
                                                    //               onChange={e => this.changeSecondaryNumbers(e, "optional", index)}/>
                                                    return <CustomInput key={index}
                                                                        labelText="Secondary Phone Number"
                                                                        success={this.state.secondaryNumberState[index] === "success"}
                                                                        error={this.state.secondaryNumberState[index] === "error"}
                                                                        // id="secondaryNumber"
                                                                        formControlProps={{
                                                                            fullWidth: true,
                                                                            required: true
                                                                        }}
                                                                        inputProps={{
                                                                            onChange: event =>
                                                                                this.changeSecondaryNumbers(event, "optional", index),
                                                                            value: number
                                                                        }}
                                                    />
                                                })}
                                                <Button block size="lg" color="warning"
                                                        onClick={(e) => this.addSecondaryContact(e)}>Add Secondary
                                                    Number
                                                </Button>

                                            </GridItem>
                                        </GridContainer>
                                    </form>
                                </CardBody>
                                <CardFooter>
                                    <GridContainer className={classes.justifyContentCenter}>
                                        <GridItem xs={12} sm={2}>
                                            <Button block size="lg" color="warning" onClick={this.typeClick}>
                                                Save
                                            </Button>
                                        </GridItem>
                                        <GridItem xs={12} sm={2}>
                                            <NavLink to={dashboardRouter("/clinic/readClinics")}>

                                                <Button block size="lg" color="grey">
                                                    Cancel
                                                </Button></NavLink>
                                            <br />
                                        </GridItem>
                                    </GridContainer>
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

}

export default withStyles(validationFormsStyle, extendedFormsStyle, customInputStyle)(ValidationForms);



// WEBPACK FOOTER //
// ./src/components/Forms/ClinicForm/ClinicForm.jsx